import { FC } from 'react';
import PresentationModal from '../../organisms/PresentationModal';

interface ParamsModalProps {
    id: string;
    show: boolean;
    params: Record<string, string>;
    onClose: () => void;
}

const ParamsModal: FC<ParamsModalProps> = ({ id, show, params, onClose }) => {
    const entries = Object.entries(params || {});

    return (
        <PresentationModal id={id} show={show} onClose={onClose} header="Parâmetros" height="300px">
            <div className="p-4">
                <table className="w-full table-auto border">
                    <thead>
                        <tr className="bg-slate-100">
                            <th className="px-2 py-1 text-left border-b">Parâmetro</th>
                            <th className="px-2 py-1 text-left border-b">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map(([key, value], index) => (
                            <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                                <td className="px-2 py-1 border-b">{key}</td>
                                <td className="px-2 py-1 border-b">{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </PresentationModal>
    );
};

export default ParamsModal;
